export default __webpack_public_path__ + "static/media/user_managemnt_orange.03fd6d4b.svg";